module.exports = __webpack_public_path__ + "media/images/flags/bb-021629a6a596929b04629ceed2c33ef4.svg";